import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'footer',
    templateUrl: 'footer.template.html'
})
export class FooterComponent implements OnInit {
fecha: number = 0; 

    ngOnInit() {
        let d = new Date();
        this.fecha = d.getFullYear();
    }

}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/footer/footer.component.ts